import * as React from 'react'
import { Outlet } from 'react-router-dom'
import { Box, CssBaseline } from '@mui/material'
import DrawerLeftMenu from '../../components/DrawerLeftMenu'
import DrawerRightInfo from '../../components/DrawerRightInfo'
import LoginModal from '../../components/LoginModal'
import DeleteRecordModal from '../../components/DeleteRecordModal'

export default function MiniDrawer() {
  return (
    <Box sx={{ display: 'flex', width: '100vw', mt: 'auto' }}>
      <CssBaseline />
      <DrawerLeftMenu />
      <Outlet />
      <DrawerRightInfo />
      <LoginModal />
      <DeleteRecordModal />
    </Box>
  )
}
